// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__1aVio","process_cell":"List_process_cell__1rZXD"};